import { useQuery } from '@tanstack/react-query';
import { useTranslation } from 'react-i18next';

import { Label } from '@/components/ui/label';
import { Listbox } from '@/components/ui/listbox';
import { api } from '@/lib/api';

interface AccountItem {
  id: string;
  name: string;
  currency: string;
}

export const HubtelAccountField = ({
  open,
  currency,
  value,
  onChange,
}: {
  open: boolean;
  currency?: string | null;
  value: string | null;
  onChange: (accountId: string | null) => void;
}) => {
  const { t } = useTranslation('payments');

  const accounts = useQuery({
    queryKey: ['financial-position', 'items', 'hubtel-account'],
    queryFn: () =>
      api.get<{ data: AccountItem[] }>('/financial-position/items?kind=hubtel_account'),
    enabled: open,
  });

  const options = (accounts.data?.data ?? [])
    .filter((account) => !currency || account.currency === currency)
    .map((account) => ({ value: account.id, label: account.name }));

  return (
    <div>
      <Label>{t('links.form.account')}</Label>
      <Listbox
        value={value}
        onChange={onChange}
        options={options}
        placeholder={options.length === 0 ? t('links.form.accountEmpty') : t('links.form.accountPlaceholder')}
        popoverPortal="dialog"
        disabled={accounts.isLoading || options.length === 0}
      />
    </div>
  );
};
